/* eslint-disable max-len */
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveLogs, getActiveLogsSilent } from 'store/container/activeLogs/activeLogs-slice';
import { TIME_ENTRY_WS_EVENT, isLocalEcho, TimeEntryWsEvent } from 'services/timeTracking';
import useWebSocket from 'utils/useWebSocket';

// A timer swap emits two events back to back (paused old + started new). Coalesce
// them into a single network refetch to avoid a redundant /timers/current call.
const SWAP_DEBOUNCE_MS = 300;

const useHeader = () => {
  const user = useSelector((store: any) => store.auth.user);
  const dispatch = useDispatch();
  const refetchTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    dispatch(getActiveLogs());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (refetchTimeoutRef.current) {
        clearTimeout(refetchTimeoutRef.current);
      }
    };
  }, []);

  useWebSocket({
    channelName: 'model.changes',
    listen: {
      event: TIME_ENTRY_WS_EVENT,
      callback: (event: TimeEntryWsEvent) => {
        if (isLocalEcho(event)) return;

        if (event.payload.user_uuid === user.uuid) {
          if (refetchTimeoutRef.current) {
            clearTimeout(refetchTimeoutRef.current);
          }

          // Silent refetch: the only intentional "loading" during a local swap is the
          // Timer's own `saving` state. Toggling activeLogs `loading` here would stack a
          // second (and third) flash on top of it. Reconcile in the background instead.
          refetchTimeoutRef.current = setTimeout(() => {
            dispatch(getActiveLogsSilent());
          }, SWAP_DEBOUNCE_MS);
        }
      },
    },
  });

  return {
    user,
  };
};

export default useHeader;
